import { AsyncPipe, CurrencyPipe, NgIf } from '@angular/common';
import { Component, inject, input, InputSignal, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ButtonModule } from 'primeng/button';
import { filter, first, last, Observable, take } from 'rxjs';
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from "primeng/floatlabel";
import { DialogModule } from "primeng/dialog";
import { ButtonGroupModule } from 'primeng/buttongroup';
import { Encounter } from '../../../models/encounter';
import { ErrorMessage } from '../../../models/errors';
import { RepricedMedicalBill, MedicalBill, EDISender, EDIPayer } from '../../../models/medical-bill';
import { MedicalService } from '../../../services/medical.service';
import { MedicalState } from '../../../state/medical/medical-state';

@Component({
  selector: 'lib-locked-repriced-bill',
  standalone: true,
  imports: [NgIf, CurrencyPipe, ButtonModule, DropdownModule, AsyncPipe, FormsModule, FloatLabelModule, DialogModule,
            ButtonGroupModule],
  templateUrl: './locked-repriced-bill.component.html',
  styleUrl: './locked-repriced-bill.component.css'
})
export class LockedRepricedBillComponent<E extends Encounter> implements OnInit
{

  repricedBill: InputSignal<RepricedMedicalBill<E>> = input.required<RepricedMedicalBill<E>>();
  originalBill: MedicalBill<E> | undefined;

  senders$: Observable<EDISender[]> | undefined;
  payers$: Observable<EDIPayer[]> | undefined;

  selectedSender: EDISender | undefined;
  selectedPayer: EDIPayer | undefined;

  _medical: MedicalService = inject(MedicalService);
  _store: Store = inject(Store);

  editorVisible: boolean = false;
  lastError: string | undefined;
  submitting: boolean = false;

  async ngOnInit(): Promise<void> 
  {
    this.senders$ = this._store.select(MedicalState.senders);
    this.payers$ = this._store.select(MedicalState.payers);

    this.senders$.pipe(filter(s => s != undefined && s != null), first()).subscribe( s=> this.selectedSender = s[0] );
    this.payers$.pipe(filter(p => p != undefined && p != null), first()).subscribe( p=> this.selectedPayer = p[0] );

    //Get the original bill that goes with this repricing...
    this.originalBill = await this._medical.getMedicalBill(this.repricedBill().originalBillId);
  }

  async submitToClearinghouse()
  {
    this.lastError = undefined;
    this.submitting = true;
    if(this.selectedPayer && this.selectedSender)
    {
      var result = await this._medical.submitMedicalBillToClearingHouse(this.repricedBill(),this.selectedPayer,this.selectedSender);
      if(!(result instanceof RepricedMedicalBill))
      {
        this.lastError = (result as ErrorMessage).message;
      }
      this.submitting = false;
    }
  }

  getSubmissionDateDisplay(): string
  {
    if(!this.originalBill?.submissionDate)
      return "N/A";
    return new Date(this.originalBill.submissionDate).toLocaleString();
  }

  getPayerSubmissionDateDisplay(): string
  {
    const bill = this.repricedBill();
    if(!bill.payerSubmissionDate)
      return "N/A";
    return new Date(bill.payerSubmissionDate).toLocaleString();
  }

}
